const translations = {
    aerialApplication: 'Aerial Application',
    aerialImaging: 'Aerial Imaging'
};

export default translations;
